module.exports = __webpack_public_path__ + "static/media/img-01.82316664.jpeg";